// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ":root {\n    --accent-color: #77AAFF;\n    --accent-light: #e9f1ff;\n    --background-color: rgb(240, 240, 240);\n\n    --gp-primary: #0d65c9;\n    --gp-secondary: #f28a14;\n    --gp-dark: #123b72;\n    --gp-text: #1a1a1a;\n    --gp-text-light: #59697c;\n    --gp-bg-light: #f7f9fc;\n}", ""]);
// Exports
module.exports = exports;
